module.exports = __webpack_public_path__ + "img/Outros.2309edab.svg";